/**
 * PrefetchLink — Link with hover/focus prefetch
 *
 * On hover or focus, preloads the target page's JS chunk + data.
 * Drop-in replacement for react-router's <Link>.
 *
 * @see Issue #618
 */
import { useCallback } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { prefetchRoute } from '@/lib/prefetch';

export function PrefetchLink({ to, onMouseEnter, onFocus, ...props }: LinkProps) {
  const path = typeof to === 'string' ? to : to.pathname ?? '';

  const handleMouseEnter = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      prefetchRoute(path);
      onMouseEnter?.(e);
    },
    [path, onMouseEnter],
  );

  const handleFocus = useCallback(
    (e: React.FocusEvent<HTMLAnchorElement>) => {
      prefetchRoute(path);
      onFocus?.(e);
    },
    [path, onFocus],
  );

  return (
    <Link
      to={to}
      onMouseEnter={handleMouseEnter}
      onFocus={handleFocus}
      {...props}
    />
  );
}
